// import React, { useMemo, useState } from 'react';
// import PropTypes from 'prop-types';
// import { USED_COUPON_STATES } from 'coupon-common';
// import ActionIcon from '../../../assets/icons/Action_Icon.svg';
// import RedirectButtonIcon from '../../../assets/icons/Redirect_ButtonIcon.svg';
// import callClaude from './callClaude';

// const ActionsPanel = ({ usedCoupons, pointsRequestsList, onCouponClick }) => {
//   const [aiResponse, setAiResponse] = useState('');
//   const [loading, setLoading] = useState(false);

//   const actionItems = useMemo(() => {
//     const items = [];
//     usedCoupons
//       .filter(c => c.state === USED_COUPON_STATES.WAITING)
//       .slice(0, 3)
//       .forEach(c =>
//         items.push({
//           id: `uc-${c.id}`,
//           user: c.customer_name,
//           action: `wants to use the coupon "${c.coupon_name}" and pay by ${c.pay_by_points ? 'Points' : 'Dollars'}.`,
//           avatar: c.customer_name ? c.customer_name.slice(0, 2).toUpperCase() : null,
//           rawCoupon: c,
//         }),
//       );
//     pointsRequestsList
//       .filter(r => r.status === 'pending')
//       .slice(0, 3)
//       .forEach(r =>
//         items.push({
//           id: `pr-${r.id}`,
//           user: r.first_name,
//           action: `has a pending points request for ${r.points} points.`,
//           avatar: r.first_name ? r.first_name.slice(0, 2).toUpperCase() : null,
//         }),
//       );
//     return items;
//   }, [usedCoupons, pointsRequestsList]);

//   const handleGetInsight = async () => {
//     setLoading(true);
//     try {
//       const text = await callClaude(
//         `I have ${actionItems.length} pending actions in my coupon business dashboard: ${actionItems
//           .map(a => (a.user ? `${a.user} ${a.action}` : a.action))
//           .join('; ')}. Give me a short 2-sentence actionable recommendation.`,
//       );
//       setAiResponse(text);
//     } catch (e) {
//       setAiResponse('Unable to fetch AI insight at this time.');
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
//       {/* Header */}
//       <div className="flex items-center justify-between px-4 py-3.5 border-b border-slate-50">
//         <div className="flex items-center gap-3">
//           <img
//             src={ActionIcon}
//             className="img-fluid w-6"

//           />
//           <span className="font-normal text-2xl  text-slate-800">Actions</span>
//         </div>
//         <button className="w-7 h-7 rounded-full  cursor-pointer  hover:bg-slate-100 transition-colors">
//           <img
//                   src={RedirectButtonIcon}
//                   className="img-fluid "

//                 />
//         </button>
//       </div>

//       {/* Items */}
//       <div className="py-2">
//         {actionItems.length === 0 ? (
//           <p className="px-4 py-4 text-slate-400 text-[13px] text-center m-0">
//             No pending actions
//           </p>
//         ) : (
//           actionItems.map(action => (
//             <div
//               key={action.id}
//               className={`flex items-center gap-3 px-4 py-2.5 border-b border-slate-50 ${action.rawCoupon ? 'cursor-pointer hover:bg-slate-50' : ''} transition-colors`}
//               onClick={() => action.rawCoupon && onCouponClick(action.rawCoupon)}
//             >
//               <div
//                 className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 font-semibold ${
//                   action.avatar
//                     ? 'bg-red-100 text-[11px] text-red-600'
//                     : 'bg-slate-50 text-base text-red-600'
//                 }`}
//               >
//                 {action.avatar || '👤'}
//               </div>
//               <p className="m-0 text-[13px] text-gray-700 leading-snug">
//                 {action.user && <strong>{action.user} </strong>}
//                 {action.action}
//               </p>
//             </div>
//           ))
//         )}
//       </div>

//       {/* AI Insight */}
//       <div className="px-4 py-3 border-t border-slate-100">
//         <button
//           onClick={handleGetInsight}
//           disabled={loading}
//           className={`w-full py-2 px-3.5 bg-red-600 text-white border-none rounded-lg text-[13px] font-semibold transition-opacity ${
//             loading ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer hover:bg-red-700'
//           }`}
//         >
//           {loading ? '✨ Getting AI Insight...' : '✨ Get AI Insight'}
//         </button>
//         {aiResponse && (
//           <div className="mt-2.5 p-2.5 bg-red-50 rounded-lg text-xs text-red-900 leading-relaxed border border-red-200">
//             {aiResponse}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// ActionsPanel.propTypes = {
//   usedCoupons: PropTypes.array.isRequired,
//   pointsRequestsList: PropTypes.array.isRequired,
//   onCouponClick: PropTypes.func.isRequired,
// };

// export default ActionsPanel;
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { USED_COUPON_STATES } from 'coupon-common';
import ActionIcon from '../../../assets/icons/Action_Icon.svg';
import RedirectButtonIcon from '../../../assets/icons/Redirect_ButtonIcon.svg';
import callClaude from './callClaude';

const ActionsPanel = ({ usedCoupons, pointsRequestsList, onCouponClick }) => {
  const [aiResponse, setAiResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const actionItems = useMemo(() => {
    const items = [];
    usedCoupons
      .filter(c => c.state === USED_COUPON_STATES.WAITING)
      .slice(0, 3)
      .forEach(c =>
        items.push({
          id: `uc-${c.id}`,
          user: c.customer_name,
          action: `wants to use the coupon "${c.coupon_name}" and pay by ${c.pay_by_points ? 'Points' : 'Dollars'}.`,
          avatar: c.customer_name ? c.customer_name.slice(0, 2).toUpperCase() : null,
          rawCoupon: c,
        }),
      );
    pointsRequestsList
      .filter(r => r.status === 'pending')
      .slice(0, 3)
      .forEach(r =>
        items.push({
          id: `pr-${r.id}`,
          user: r.first_name,
          action: `has a pending points request for ${r.points} points.`,
          avatar: r.first_name ? r.first_name.slice(0, 2).toUpperCase() : null,
        }),
      );
    return items;
  }, [usedCoupons, pointsRequestsList]);

  const handleGetInsight = async () => {
    setLoading(true);
    try {
      const text = await callClaude(
        `I have ${actionItems.length} pending actions in my coupon business dashboard: ${actionItems
          .map(a => (a.user ? `${a.user} ${a.action}` : a.action))
          .join('; ')}. Give me a short 2-sentence actionable recommendation.`,
      );
      setAiResponse(text);
    } catch (e) {
      setAiResponse('Unable to fetch AI insight at this time.');
    }
    setLoading(false);
  };

  /* ── Person SVG icon matching the image ── */
  const PersonIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="10" r="4" stroke="#8B1A2A" strokeWidth="1.5"/>
      <path d="M3 24c0-4.418 3.582-8 8-8s8 3.582 8 8" stroke="#8B1A2A" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="21" cy="10" r="3" stroke="#8B1A2A" strokeWidth="1.3"/>
      <path d="M25 21c0-2.761-1.791-5-4-5" stroke="#8B1A2A" strokeWidth="1.3" strokeLinecap="round"/>
      {/* small coin/dollar badge */}
      <circle cx="20" cy="21" r="4" fill="#8B1A2A"/>
      <text x="20" y="24.5" textAnchor="middle" fontSize="5.5" fill="white" fontWeight="bold">$</text>
    </svg>
  );

  return (
    <div style={{
        background: '#F0EAEA', borderRadius: '24px', padding: '20px 16px',
        fontFamily: "'Segoe UI', sans-serif",
        height: '700px', display: 'flex', flexDirection: 'column',
      }}>
      {/* ── Header ── */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {/* 4-dot grid icon */}
          <img
            src={ActionIcon}
            className="img-fluid w-6"

          />
          <span style={{ fontSize: '24px', fontWeight: '400', color: '#1a1a1a' }}>Actions</span>
        </div>
        <button className="w-7 h-7 rounded-full  cursor-pointer  hover:bg-slate-100 transition-colors">
          <img
                  src={RedirectButtonIcon}
                   className="img-fluid "

                />
         </button>
      </div>

      {/* ── Action items ── */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {actionItems.length === 0 ? (
          <p style={{ color: '#aaa', fontSize: '13px', textAlign: 'center', padding: '16px 0', margin: 0 }}>
            No pending actions
          </p>
        ) : (
          actionItems.map(action => (
            <div
              key={action.id}
              onClick={() => action.rawCoupon && onCouponClick(action.rawCoupon)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '14px 14px',
                background: 'white',
                borderRadius: '16px',
                cursor: action.rawCoupon ? 'pointer' : 'default',
                border: '1px solid #f0e8e8',
              }}
            >
              {/* Avatar circle */}
              <div style={{
                width: '40px', height: '40px',
                borderRadius: '50%',
                background: '#fce8ea',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0,
              }}>
                <PersonIcon />
              </div>

              {/* Text */}
              <p style={{ margin: 0, fontSize: '13px', color: '#444', lineHeight: 1.45 }}>
                {action.user && <strong style={{ color: '#1a1a1a' }}>{action.user} </strong>}
                {action.action}
              </p>
            </div>
          ))
        )}
      </div>

      {/* ── AI Insight ── */}
      {/* <div style={{ marginTop: '14px' }}>
        <button
          onClick={handleGetInsight}
          disabled={loading}
          style={{
            width: '100%',
            padding: '10px 14px',
            background: 'linear-gradient(135deg, #EF0023, #D4001D)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '13px',
            fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1,
            boxShadow: '0 4px 12px rgba(212,0,29,0.3)',
          }}
        >
          {loading ? '✨ Getting AI Insight...' : '✨ Get AI Insight'}
        </button>
        {aiResponse && (
          <div style={{
            marginTop: '10px', padding: '10px 14px',
            background: '#fff0f0', borderRadius: '10px',
            fontSize: '12px', color: '#7f1d1d',
            lineHeight: 1.5, border: '1px solid #f5c6c6',
          }}>
            {aiResponse}
          </div>
        )}
      </div> */}
    </div>
  );
};

ActionsPanel.propTypes = {
  usedCoupons: PropTypes.array.isRequired,
  pointsRequestsList: PropTypes.array.isRequired,
  onCouponClick: PropTypes.func.isRequired,
};

export default ActionsPanel;